import gql from 'graphql-tag'
import { EnumFields } from '..'

export const PropertyTypeFragment = gql`
  fragment PropertyType on persons_property_type {
    ${EnumFields}
  }
`
